import {useAuth} from "../../providers/AuthProvider";
import {Navigate, Outlet, useLocation} from "react-router-dom";

export function RequireAuth() {
    let auth = useAuth();
    let location = useLocation();

    if (!auth.user) {
        return <Navigate to="/error" state={{from: location}}/>;
    }

    return <Outlet/>;
}
